var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "a-layout-content",
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { attrs: { span: 24 } },
                [
                  _c(
                    "a-card",
                    { attrs: { title: "Inquiry Reclass" } },
                    [
                      _c(
                        "a-tabs",
                        {
                          attrs: {
                            "default-active-key": "Reclass",
                            activeKey: "Reclass",
                            type: "card"
                          }
                        },
                        [
                          _c(
                            "a-tab-pane",
                            {
                              key: "Reclass",
                              staticClass: "bordertabs p-3",
                              attrs: { tab: "Reclass" }
                            },
                            [
                              _c(
                                "a-row",
                                { staticStyle: { "margin-bottom": "1rem" } },
                                [
                                  _c("a-col", { attrs: { span: 11 } }, [
                                    _c("h2", [_vm._v("Search Data")])
                                  ])
                                ],
                                1
                              ),
                              _c(
                                "a-form",
                                _vm._b(
                                  {
                                    attrs: {
                                      layout: "vertical",
                                      form: _vm.form
                                    },
                                    on: {
                                      submit: function($event) {
                                        $event.preventDefault()
                                        return _vm.submitForm.apply(
                                          null,
                                          arguments
                                        )
                                      }
                                    }
                                  },
                                  "a-form",
                                  _vm.formItemLayout,
                                  false
                                ),
                                [
                                  _c(
                                    "a-row",
                                    [
                                      _c(
                                        "a-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            {
                                              staticStyle: {
                                                "margin-top": "1rem"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.leasingNumber
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules
                                                        .leasingNumber
                                                        .decorator,
                                                    expression:
                                                      "formRules.leasingNumber.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.leasingNumber
                                                      .name,
                                                  placeholder: _vm.$t(
                                                    _vm.formRules.leasingNumber
                                                      .placeholder
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-model-item",
                                            {
                                              staticStyle: {
                                                "margin-top": "1rem"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.unitCode.label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.unitCode
                                                        .decorator,
                                                    expression:
                                                      "formRules.unitCode.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.unitCode.name,
                                                  placeholder: _vm.$t(
                                                    _vm.formRules.unitCode
                                                      .placeholder
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-model-item",
                                            {
                                              staticStyle: {
                                                "margin-top": "1rem"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.serialNumber
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-input", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.serialNumber
                                                        .decorator,
                                                    expression:
                                                      "formRules.serialNumber.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.serialNumber
                                                      .name,
                                                  placeholder: _vm.$t(
                                                    _vm.formRules.serialNumber
                                                      .placeholder
                                                  )
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-model-item",
                                            {
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.status.label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-select", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.status
                                                        .decorator,
                                                    expression:
                                                      "formRules.status.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  name:
                                                    _vm.formRules.status.name,
                                                  "data-testid": "status",
                                                  placeholder: _vm.$t(
                                                    "common.select-text",
                                                    {
                                                      text: _vm.$t("status")
                                                    }
                                                  ),
                                                  options: _vm.statusOptions
                                                }
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      ),
                                      _c(
                                        "a-col",
                                        { attrs: { span: 12 } },
                                        [
                                          _c(
                                            "a-form-model-item",
                                            {
                                              staticStyle: {
                                                "margin-top": "1rem"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.reclassDate
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c("a-range-picker", {
                                                directives: [
                                                  {
                                                    name: "decorator",
                                                    rawName: "v-decorator",
                                                    value:
                                                      _vm.formRules.reclassDate
                                                        .decorator,
                                                    expression:
                                                      "formRules.reclassDate.decorator"
                                                  }
                                                ],
                                                attrs: {
                                                  ranges: {
                                                    Today: [
                                                      _vm.moment(),
                                                      _vm.moment()
                                                    ],
                                                    "This Month": [
                                                      _vm.moment(),
                                                      _vm
                                                        .moment()
                                                        .endOf("month")
                                                    ]
                                                  },
                                                  name:
                                                    _vm.formRules.reclassDate
                                                      .name,
                                                  format:
                                                    _vm.DEFAULT_DATE_FORMAT,
                                                  type: "date"
                                                }
                                              })
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-model-item",
                                            {
                                              staticStyle: {
                                                "margin-top": "1rem"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.oldCategory
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "decorator",
                                                      rawName: "v-decorator",
                                                      value:
                                                        _vm.formRules
                                                          .oldCategory
                                                          .decorator,
                                                      expression:
                                                        "formRules.oldCategory.decorator"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      _vm.formRules.oldCategory
                                                        .name,
                                                    placeholder: _vm.$t(
                                                      _vm.formRules.oldCategory
                                                        .placeholder
                                                    ),
                                                    showSearch: true,
                                                    "option-filter-prop":
                                                      "children",
                                                    "filter-option":
                                                      _vm.filterOption,
                                                    loading:
                                                      _vm.loadingOldCategory,
                                                    allowClear: true
                                                  },
                                                  on: {
                                                    search: function(value) {
                                                      return _vm.getListOldCategory(
                                                        value,
                                                        _vm.idBook
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.dataOldCategory,
                                                  function(data) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: data.key,
                                                        attrs: {
                                                          value: data.idForView
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a-tooltip",
                                                          [
                                                            _c(
                                                              "template",
                                                              { slot: "title" },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.idForView
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.idForView
                                                                ) +
                                                                " "
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          ),
                                          _c(
                                            "a-form-model-item",
                                            {
                                              staticStyle: {
                                                "margin-top": "1rem"
                                              },
                                              attrs: {
                                                label: _vm.$t(
                                                  _vm.formRules.newCategory
                                                    .label
                                                )
                                              }
                                            },
                                            [
                                              _c(
                                                "a-select",
                                                {
                                                  directives: [
                                                    {
                                                      name: "decorator",
                                                      rawName: "v-decorator",
                                                      value:
                                                        _vm.formRules
                                                          .newCategory
                                                          .decorator,
                                                      expression:
                                                        "formRules.newCategory.decorator"
                                                    }
                                                  ],
                                                  attrs: {
                                                    name:
                                                      _vm.formRules.newCategory
                                                        .name,
                                                    placeholder: _vm.$t(
                                                      _vm.formRules.newCategory
                                                        .placeholder
                                                    ),
                                                    showSearch: true,
                                                    "option-filter-prop":
                                                      "children",
                                                    "filter-option":
                                                      _vm.filterOption,
                                                    loading:
                                                      _vm.loadingOldCategory,
                                                    allowClear: true
                                                  },
                                                  on: {
                                                    search: function(value) {
                                                      return _vm.getListOldCategory(
                                                        value,
                                                        _vm.idBook
                                                      )
                                                    }
                                                  }
                                                },
                                                _vm._l(
                                                  _vm.dataOldCategory,
                                                  function(data) {
                                                    return _c(
                                                      "a-select-option",
                                                      {
                                                        key: data.key,
                                                        attrs: {
                                                          value: data.idForView
                                                        }
                                                      },
                                                      [
                                                        _c(
                                                          "a-tooltip",
                                                          [
                                                            _c(
                                                              "template",
                                                              { slot: "title" },
                                                              [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      data.idForView
                                                                    ) +
                                                                    " "
                                                                )
                                                              ]
                                                            ),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  data.idForView
                                                                ) +
                                                                " "
                                                            )
                                                          ],
                                                          2
                                                        )
                                                      ],
                                                      1
                                                    )
                                                  }
                                                ),
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-row",
                                    {
                                      staticStyle: {
                                        display: "flex",
                                        "column-gap": "8px",
                                        "justify-content": "flex-end",
                                        "margin-right": "2rem"
                                      }
                                    },
                                    [
                                      _c(
                                        "a-button",
                                        { on: { click: _vm.handleReset } },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("lbl_reset")) +
                                              " "
                                          )
                                        ]
                                      ),
                                      _c(
                                        "a-button",
                                        {
                                          attrs: {
                                            type: "primary",
                                            loading: _vm.loading
                                          },
                                          on: { click: _vm.submitForm }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(_vm.$t("lbl_find_data")) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _c(
                                "a-row",
                                [
                                  _c(
                                    "a-col",
                                    {
                                      staticStyle: { "margin-top": "1rem" },
                                      attrs: { span: 24 }
                                    },
                                    [
                                      _c("TableCustom", {
                                        attrs: {
                                          onSelectChange: _vm.onSelectChange,
                                          selectedRowKeys: _vm.selectedRowKeys,
                                          "get-checkbox-props":
                                            _vm.getCheckboxProps,
                                          dataSource: _vm.dataSource,
                                          columns: _vm.columnsTable,
                                          scroll: {
                                            x: "calc(700px + 50%)",
                                            y: 400
                                          },
                                          paginationcustom: true,
                                          defaultPagination: false,
                                          loading: _vm.loadingFind,
                                          rowKey: function(record) {
                                            return record.id
                                          }
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    { attrs: { span: 12 } },
                                    [
                                      _c(
                                        "a-space",
                                        {
                                          staticStyle: { height: "50px" },
                                          attrs: { align: "center" }
                                        },
                                        [
                                          _c("Pagination", {
                                            attrs: {
                                              total:
                                                _vm.totalElements === 0
                                                  ? 1
                                                  : _vm.totalElements,
                                              pageSizeSet: _vm.limit,
                                              idPagination: "pagination1"
                                            },
                                            on: {
                                              "response-pagesize-change":
                                                _vm.responsePageSizeChange,
                                              "response-currentpage-change":
                                                _vm.responseCurrentPageChange
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c(
                                    "a-col",
                                    {
                                      staticClass: "mt-2",
                                      attrs: { span: 12, align: "end" }
                                    },
                                    [
                                      _c(
                                        "a-tag",
                                        {
                                          staticStyle: { "font-size": "13px" },
                                          attrs: { color: "#8c8c8c" }
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.$t("lbl_total_found")
                                              ) +
                                              " : " +
                                              _vm._s(_vm.totalElements) +
                                              " "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm.selectedRowKeys.length > 0
                                    ? _c(
                                        "a-col",
                                        {
                                          staticClass: "mt-5",
                                          attrs: { span: 12, align: "end" }
                                        },
                                        [
                                          _c(
                                            "a-button",
                                            {
                                              attrs: {
                                                type: "primary",
                                                loading: _vm.loadingApprove,
                                                "data-testid":
                                                  "inquiry-class-btn-approve"
                                              },
                                              on: {
                                                click: _vm.handlePopupApprove
                                              }
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t("lbl_approve")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "a-modal",
            {
              attrs: { maskClosable: false, keyboard: false, title: "Reclass" },
              on: { ok: _vm.submitFormModal },
              model: {
                value: _vm.visible,
                callback: function($$v) {
                  _vm.visible = $$v
                },
                expression: "visible"
              }
            },
            [
              _c(
                "a-form",
                _vm._b(
                  {
                    attrs: { layout: "vertical", form: _vm.formModal },
                    on: {
                      submit: function($event) {
                        $event.preventDefault()
                        return _vm.submitFormModal.apply(null, arguments)
                      }
                    }
                  },
                  "a-form",
                  _vm.formItemLayout,
                  false
                ),
                [
                  _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-top": "1rem" },
                      attrs: {
                        label: _vm.$t(_vm.formRulesModal.reclassDate.label)
                      }
                    },
                    [
                      _c("a-date-picker", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: _vm.formRulesModal.reclassDate.decorator,
                            expression: "formRulesModal.reclassDate.decorator"
                          }
                        ],
                        staticStyle: { width: "100%" },
                        attrs: {
                          name: _vm.formRulesModal.reclassDate.name,
                          placeholder:
                            _vm.formRulesModal.reclassDate.placeholder,
                          format: _vm.DEFAULT_DATE_FORMAT
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "a-form-model-item",
                    {
                      staticStyle: { "margin-top": "1rem" },
                      attrs: {
                        label: _vm.$t(_vm.formRulesModal.newCategory.label)
                      }
                    },
                    [
                      _c(
                        "a-select",
                        {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: _vm.formRulesModal.newCategory.decorator,
                              expression: "formRulesModal.newCategory.decorator"
                            }
                          ],
                          attrs: {
                            name: _vm.formRulesModal.newCategory.name,
                            placeholder:
                              _vm.formRulesModal.newCategory.placeholder,
                            showSearch: true,
                            "option-filter-prop": "children",
                            "filter-option": _vm.filterOption,
                            loading: _vm.loadingNewCategory,
                            allowClear: true
                          },
                          on: {
                            search: function(value) {
                              return _vm.getListNewCategory(value)
                            }
                          }
                        },
                        _vm._l(_vm.dataNewCategory, function(data, index) {
                          return _c(
                            "a-select-option",
                            { key: index, attrs: { value: data.id } },
                            [
                              _c(
                                "a-tooltip",
                                [
                                  _c("template", { slot: "title" }, [
                                    _vm._v(" " + _vm._s(data.idForView) + " ")
                                  ]),
                                  _vm._v(" " + _vm._s(data.idForView) + " ")
                                ],
                                2
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }